'use client';

import { createContext } from 'react';

import type { CarouselRootContextInterface } from '../types/carousel-root.types';

export const CarouselRootContext = createContext<CarouselRootContextInterface>({});

CarouselRootContext.displayName = 'Carousel.Root.Context';
